export default __webpack_public_path__ + "static/media/Products_Payroll.2e0cc0ee.png";